export default {
  applications: "firms",
  profiles: "firms/profiles",
  findExisting: "firms/find-existing",
  initiateActivation: "firms/initiate-activation",
  verifyActivation: "firms/verify-activation",
  firmDetails: (profileID) => `firms/details/${profileID}`,
  firmSubscriptions: (profileID) => `firms/subscriptions/${profileID}`,
  firmLicenses: (profileID) => `firms/licenses/${profileID}`,
};